import React, { useState, useRef } from "react";
import InputWrapper from "./inputWrapper";
import classNames from "classnames";
import { ReactComponent as Arrow } from "../assets/icons/Arrow.svg";
import useOnclickOutside from "hooks/useOnClickOutside";

const Select = ({
  options,
  value,
  onChange,
  label,
  rest,
  iconRight,
  placeholder,
}) => {
  const inputClasses = classNames(
    "w-full	border rounded-5 focus:ring-0 focus:outline-none p-7 py-4 h-[50px]",
    "text-base font-regular border-blue-80 bg-white active:bg-white"
  );
  const dropDownRef = useRef(null);

  const [open, setOpen] = useState();
  const toggleSetting = () => setOpen(false);
  useOnclickOutside(toggleSetting, dropDownRef);

  return (
    <div
      className="flex flex-col w-full relative"
      ref={dropDownRef}
      onClick={() => {
        setOpen(!open);
      }}
    >
      <InputWrapper iconRight={iconRight} label={label} classes={undefined}>
        <input
          className={inputClasses}
          type="text"
          value={value}
          placeholder={placeholder}
          readOnly
        />

        <div className="absolute inset-y-0 right-5 flex items-center justify-center">
          <button type="button" className="focus:outline-none ">
            <Arrow className="w-6 h-4 rotate-[90deg]" />
          </button>
        </div>
      </InputWrapper>
      {open && (
        <div className="absolute mt-[50px] z-10	bg-white w-full shadow-inner	rounded">
          {options.map((option) => (
            <div
              key={option.value}
              value={option.value}
              className="hover:bg-[#A9A9A9]  hover:cursor-pointer h-[45px] flex items-center justify-center "
              onClick={() => {
                onChange(option);
                setOpen(false);
              }}
            >
              {option.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Select;
